module.exports = __webpack_public_path__ + "img/example-students-content-with-zones.e2336f2a.png";